import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation } from 'react-query';
import { CHANGE_ORIGIN } from 'lib/const/AccountChange';

export interface UpdateMultipleUsersBody {
  userIds: number[];
  status?: number;
  customerId?: number;
}

export const bulkUpdateUsersCustomerAndStatus = async (
  data: UpdateMultipleUsersBody
) => {
  const response = await EXPRESS_API.put(
    `/superadmin/users/status-and-customer`,
    data,
    {
      withCredentials: true,
      params: { changeOrigin: CHANGE_ORIGIN.adminManageUsers },
    }
  );
  return response.data;
};

export const useBulkUpdateUsersCustomerAndStatus = (
  closeModal?: () => void
) => {
  return useMutation(bulkUpdateUsersCustomerAndStatus, {
    onSuccess: async (_, variables: UpdateMultipleUsersBody) => {
      if (closeModal) {
        closeModal();
      }
      successToast({
        title: `Details updated successfully for ${
          variables.userIds.length
        } user${variables.userIds.length > 1 ? 's' : ''}!`,
      });
    },
    onError: () => {
      if (closeModal) {
        closeModal();
      }
      errorToast({
        title: 'There was an error with the user update. Please try again.',
      });
    },
  });
};
